import React, { useEffect, useState, useContext } from "react";
import moment from 'moment-timezone';

import { Box, Grid, TextareaAutosize, Typography, Button, InputLabel, Stack, Paper } from "@mui/material";
import PageTitle from "../../common/PageTitle";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import Loader from '../../common/Loader'
import { getAPI, postAPI, patchAPI, deleteAPI } from '../../network'

import TextField from '@mui/material/TextField';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from "@mui/x-date-pickers";

import AccountMenu from '../../layout/AccountMenu'

import "./style.css";
import { formatDate, formatDatePost, getSetTime, timeFormat, getTimeFromTimestamp2, validation, fullName, checkAuthority, tableHeader, tableData, durationCalc } from "../../utils";
import { useNavigate } from "react-router-dom";

// ... [imports remain unchanged]

export default function NotificationPage() {
    let companyId = localStorage.getItem('companyIdLS') || undefined;

    const [id, setId] = useState('');
    const [loader, setLoader] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [open, setOpen] = useState(false);
    const [show, setShow] = useState(false);
    const [sites, setSites] = useState([]);
    const [recurrences, setRecurrences] = useState([]);
    const [roles, setRoles] = useState([]);
    const [checked, setChecked] = useState([]);

    const navigate = useNavigate();

    const initialNotification = {
        notes: '',
        startTime: null,
        endTime: null,
        startDate: null,
        endDate: null,
        shiftRecurrence: null,
        siteId: '',
        vendor: '',
        role: '',
        userId: '',
        company: companyId,
        duration: '',
        endType: '',
        recurrenceDay: [],
        durationError: false,
        notesError: false,
        startTimeError: false,
        endTimeError: false,
        startDateError: false,
        endDateError: false,
        shiftRecurrenceError: false,
        siteIdError: false,
        userIdError: false,
        companyIdError: false,
        vendorIdError: false,
        recurrenceDayError: false,
        endTypeError: false,
    };

    const [notification, setNotification] = useState(initialNotification);

    const checkListWeek = [
        { name: "Mon", val: 0 },
        { name: "Tue", val: 1 },
        { name: "Wed", val: 2 },
        { name: "Thu", val: 3 },
        { name: "Fri", val: 4 },
        { name: "Sat", val: 5 },
        { name: "Sun", val: 6 }
    ];

    useEffect(() => {
        getSites();
        getRecurrences();
        getRoles();
    }, []);

    const clearAll = () => {
        setNotification({ ...initialNotification });
        setChecked([]);
    };

    const getNotifications = async () => {
        setLoader(true);
        let url = companyId ? `/notifications?company=${companyId}` : `/notifications`;
        const data = await getAPI(url);
        if (data) setNotifications(data);
        setLoader(false);
    };

    const getSites = async (cIdd) => {
        setLoader(true);
        const data = await getAPI(`/sites?companyId=${cIdd || companyId}`);
        if (data) setSites(data);
        setLoader(false);
    };

    const getRoles = async (cId, sId) => {
        setLoader(true);
        const query = cId && sId ? `?siteId=${sId}&companyId=${cId}` :
            sId ? `?siteId=${sId}` :
                cId ? `?companyId=${cId}` : '';
        const data = await getAPI(`/roles${query}`);
        if (data) setRoles(data);
        setLoader(false);
    };

    const getRecurrences = async () => {
        setLoader(true);
        const data = await getAPI('/recurrence');
        if (data) {
            const arr = data.map(d => ({ id: d.id, name: d.name, checked: false }));
            setRecurrences(arr);
        }
        setLoader(false);
    };

    const findDuration = (from = null, to = null) => {
        const start = from ?? notification.startTime;
        const end = to ?? notification.endTime;
        if (start && end) return durationCalc(start, end);
        return null;
    };

    const handleSubmit = async (action) => {
        let errors = {};

        if (validation('empty', 'Company', notification.company)) errors.companyIdError = true;
        if (validation('long', 'Notification', notification.notes)) errors.notesError = true;
        if (validation('time', 'Start Time', notification.startTime)) errors.startTimeError = true;
        if (validation('time', 'End Time', notification.endTime)) errors.endTimeError = true;
        if (notification.startTime && notification.endTime && notification.startTime >= notification.endTime) {
            errors.durationError = true;
        }
        if (validation('date', 'Start Date', notification.startDate)) errors.startDateError = true;
        if (validation('date', 'End Date', notification.endDate)) errors.endDateError = true;
        if (notification.startDate && notification.endDate && notification.startDate > notification.endDate) {
            errors.endDateError = true;
        }
        if (validation('empty', 'RecurrenceDay', checked)) errors.recurrenceDayError = true;

        if (Object.keys(errors).length > 0) {
            setNotification(prev => ({ ...prev, ...errors }));
            return;
        }

        const checkedval = checked.length > 0 ? checked.map(Number) : checkListWeek.map(d => d.val);

        const payload = {
            notification: notification.notes,
            notes: notification.notes,
            startTime: moment(notification.startTime).utc().format(),
            endTime: moment(notification.endTime).utc().format(),
            startDate: formatDatePost(notification.startDate),
            endDate: formatDatePost(notification.endDate),
            shiftRecurrence: "Weekly",
            siteId: notification.siteId || null,
            role: notification.role || null,
            vendor: notification.vendor || null,
            duration: notification.duration,
            userId: notification.userId || null,
            company: notification.company,
            endType: notification.endType,
            recurrenceDay: checkedval
        };

        setLoader(true);
        const apiCall = action === 'add' ? postAPI('/notifications', payload) : patchAPI(`/notifications/${id}`, payload);
        const data = await apiCall;
        if (data) {
            setOpen(false);
            getNotifications();
            clearAll();
            navigate('/notifications/view');
        }
        setLoader(false);
    };

    const handleChange = (event) => {
        setNotification(prev => ({ ...prev, siteId: event.target.value }));
        getRoles(null, event.target.value);
    };

    const handleRoleChange = (event) => {
        setNotification(prev => ({ ...prev, role: event.target.value }));
    };

    const onStartDateChange = (data) => {
        setNotification(prev => ({
            ...prev,
            startTime: data,
            duration: findDuration(data, null),
        }));
    };

    const onEndDateChange = (data) => {
        setNotification(prev => ({
            ...prev,
            endTime: data,
            duration: findDuration(null, data),
        }));
    };

    const isChecked = (itemVal) => checked.includes(itemVal) ? "checked-item" : "not-checked-item";

    const handleCheck = (event) => {
        const val = event.target.value;
        setChecked(prev => event.target.checked ? [...prev, val] : prev.filter(v => v !== val));
    };
    return (
        <Box sx={{ height: "inherit", p: 2 }}>
            <Loader loader={loader} />
            <PageTitle title="Create Notification" />

            {checkAuthority('ADD_NOTIFICATION') && (
                <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
                    <Grid container spacing={3}>
                        {/* Site and Role */}
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel id="site-label">Site *</InputLabel>
                                <Select
                                    labelId="site-label"
                                    value={notification.siteId}
                                    label="Site"
                                    error={notification.siteIdError}
                                    onChange={handleChange}
                                >
                                    {sites.map((item, index) => (
                                        <MenuItem value={item?._id} key={index}>{item?.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel id="role-label">Role</InputLabel>
                                <Select
                                    labelId="role-label"
                                    value={notification.role}
                                    label="Role"
                                    error={notification.roleError}
                                    onChange={handleRoleChange}
                                >
                                    {roles.map((item, index) => (
                                        <MenuItem value={item?.id || item?._id} key={index}>{item?.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Notification */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" sx={{ mb: 1 }}>Notification*</Typography>
                            <TextareaAutosize
                                minRows={4}
                                placeholder="Type notification here"
                                className={notification.notesError ? "txt-input-error" : "txt-input"}
                                onChange={(e) => setNotification(prev => ({ ...prev, notes: e.target.value }))}
                                value={notification.notes}
                                style={{ width: '100%', padding: 12, borderRadius: 4, fontSize: 16 }}
                            />
                            {notification.notesError && (
                                <Typography color="error" variant="caption">Please enter a valid message.</Typography>
                            )}
                        </Grid>

                        {/* Appointment Recurrence */}
                        <Grid item xs={12} md={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                    label="Start Time *"
                                    value={notification.startTime}
                                    onChange={onStartDateChange}
                                    renderInput={(params) => (
                                        <TextField fullWidth {...params} error={notification.startTimeError} />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                    label="End Time *"
                                    value={notification.endTime}
                                    onChange={onEndDateChange}
                                    renderInput={(params) => (
                                        <TextField fullWidth {...params} error={notification.endTimeError} />
                                    )}
                                />
                            </LocalizationProvider>
                            {notification.durationError && (
                                <Typography color="error" variant="caption">End time must be after start time.</Typography>
                            )}
                        </Grid>

                        {/* Recurrence Days */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" sx={{ mb: 1 }}>Recurrence Pattern*</Typography>
                            <Stack direction="row" spacing={2} flexWrap="wrap">
                                {checkListWeek.map(({ name, val }) => (
                                    <label key={val} style={{ display: 'flex', alignItems: 'center' }}>
                                        <input
                                            type="checkbox"
                                            value={val}
                                            checked={checked.includes(val.toString())}
                                            onChange={handleCheck}
                                            style={{ marginRight: 6 }}
                                        />
                                        <span className={isChecked(val.toString())}>{name}</span>
                                    </label>
                                ))}
                            </Stack>
                            {notification.recurrenceDayError && (
                                <Typography color="error" variant="caption">Select at least one day.</Typography>
                            )}
                        </Grid>

                        {/* Date Range */}
                        <Grid item xs={12} md={6}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Start Date *"
                                    value={notification.startDate}
                                    onChange={(date) => setNotification(prev => ({ ...prev, startDate: date }))}
                                    renderInput={(params) => (
                                        <TextField fullWidth {...params} error={notification.startDateError} />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="End Date *"
                                    value={notification.endDate}
                                    onChange={(date) => setNotification(prev => ({ ...prev, endDate: date }))}
                                    renderInput={(params) => (
                                        <TextField fullWidth {...params} error={notification.endDateError} />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>

                        {/* Action Buttons */}
                        <Grid item xs={12}>
                            <Stack direction="row" justifyContent="center" spacing={4} mt={2}>
                                <Button variant="contained" onClick={() => handleSubmit('add')}>
                                    Submit
                                </Button>
                                <Button variant="outlined" onClick={clearAll}>
                                    Cancel
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </Paper>
            )}
        </Box>
    );
}
